export default __webpack_public_path__ + "static/media/tinder-beach.5594b339.jpg";